import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import {
  logoutUser,
  markEutcAccepted,
  clearMustChangePassword,
} from '../store/authSlice';
import EutcAcceptanceModal from './EutcAcceptanceModal';
import ForcePasswordChangeModal from './ForcePasswordChangeModal';

/**
 * Mounts the blocking post-login gates over the whole authenticated app:
 *
 * 1. EUTC acceptance — when termsStatus?.eutcAccepted === false.
 * 2. Forced password change — when termsStatus?.mustChangePassword === true
 *    (shown after the EUTC gate clears when both apply).
 *
 * termsStatus is absent on older backends; absent (null) means "no gate".
 */
const TermsGates: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, termsStatus } = useAppSelector(
    (state) => state.auth
  );

  const handleLogout = useCallback(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  const handleEutcAccepted = useCallback(() => {
    dispatch(markEutcAccepted());
  }, [dispatch]);

  const handlePasswordChanged = useCallback(() => {
    dispatch(clearMustChangePassword());
  }, [dispatch]);

  if (!isAuthenticated) {
    return null;
  }

  if (termsStatus?.eutcAccepted === false) {
    return (
      <EutcAcceptanceModal
        onAccepted={handleEutcAccepted}
        onLogout={handleLogout}
      />
    );
  }

  if (termsStatus?.mustChangePassword === true) {
    return (
      <ForcePasswordChangeModal
        onPasswordChanged={handlePasswordChanged}
        onLogout={handleLogout}
      />
    );
  }

  return null;
};

export default TermsGates;
